import {
  EnterpriseStorefrontContextValue,
  EnterpriseStorefrontProvider,
  useEnterpriseStorefrontContext,
} from 'src/dispensary/enterprise-storefront-context';

export type HomeMenuContextValue = EnterpriseStorefrontContextValue;

// Compatibility aliases for the homepage while enterprise custom pages adopt
// the same storefront-wide context.
export const HomeMenuProvider = EnterpriseStorefrontProvider;
export const useHomeMenuContext = useEnterpriseStorefrontContext;
